import { render, staticRenderFns } from "./RolSocial.vue?vue&type=template&id=57d31766&scoped=true&"
import script from "./RolSocial.vue?vue&type=script&lang=ts&"
export * from "./RolSocial.vue?vue&type=script&lang=ts&"
import style0 from "./RolSocial.vue?vue&type=style&index=0&id=57d31766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d31766",
  null
  
)

export default component.exports